import { ValidatorsProps, Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import { Category, FormValues } from '../../types';

export interface CreateCategoryValidatorResponse {
  data: {
    createAccountCategorySchema: ValidatorsProps;
  };
}

export const accountsCategoriesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCreateCategoryValidator: build.query<
      CreateCategoryValidatorResponse,
      void
    >({
      query: () => ({
        url: '/v1/accounts-categories/validators',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsCategories: build.query<Response<Category>, string>({
      query: (query) => ({
        url: `/v1/accounts-categories?${query}`,
      }),
    }),
    createCategory: build.mutation<{ data: Category }, any>({
      query: (body: FormValues) => ({
        url: '/v1/accounts-categories',
        method: 'POST',
        body: {
          name: body.name,
          type: body.type,
          active: true,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsCategory: build.query<{ data: Category }, string>({
      query: (id) => ({
        url: `/v1/accounts-categories/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateCategory: build.mutation<
      { data: Category },
      { body: FormValues; id: string }
    >({
      query: (data: { body: FormValues; id: string }) => ({
        url: `/v1/accounts-categories/${data.id}`,
        method: 'PUT',
        body: {
          name: data.body.name,
          active: data.body.active,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetCreateCategoryValidatorQuery,
  useGetAccountsCategoriesQuery,
  useCreateCategoryMutation,
  useGetAccountsCategoryQuery,
  useUpdateCategoryMutation,
  useLazyGetAccountsCategoriesQuery,
} = accountsCategoriesApi;

export const {
  endpoints: {
    getCreateCategoryValidator,
    getAccountsCategories,
    createCategory,
    getAccountsCategory,
    updateCategory,
  },
} = accountsCategoriesApi;
